module.exports = __webpack_public_path__ + "static/media/ball_5_7.b71cc3c1.mp3";